/**
 *
 */

const gradientFadeOutColor = {
    neutral: '#F2F2F2',
    primary: '#EBEBEB',
    primary2: '#FFFFFF',
    secondary: '#EBEBEB',
    tertiary: '#E5E5E5',
    destructive: '#FFFFFF'
}

/**
 *
 */
const style = (t) => {
    const { colors, typography } = t['foundations-library']
    return {
        alert: {
            ...typography.subtitle2,
            borderRadius: '6px',
            padding: '8px 30px',
            display: 'flex',
            textAlign: ({ textAlign }) => textAlign,
            alignItems: 'center',
            gap: '20px',
            flexShrink: 0,
            minHeight: '50px',
            '& .alert--content': {
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                '& .alert--content-inner': {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                }
            },
            '&.alert--no-border-radius': {
                borderRadius: '0 !important'
            },
            '&.alert--error': {
                color: ({ withGradient }) => withGradient ? colors.neutral[900] : 'white',
                background:
                    ({ withGradient }) =>
                        withGradient
                            ? `linear-gradient(78.05deg, ${gradientFadeOutColor.destructive} 9.2%, ${colors.destructive[50]} 91.7%)`
                            : colors.destructive[400]
            },
            '&.alert--success': {
                color: ({ withGradient }) => withGradient ? colors.neutral[900] : colors.primary[500],
                background:
                    ({ withGradient }) =>
                        withGradient
                            ? `linear-gradient(78.05deg, ${gradientFadeOutColor.primary} 9.2%, ${colors.primary[50]} 91.7%)`
                            : colors.primary[50]
            },
            '&.alert--warning': {
                color: ({ withGradient }) => withGradient ? colors.neutral[900] : colors.primary2[500],
                background:
                    ({ withGradient }) =>
                        withGradient
                            ? `linear-gradient(78.05deg, ${gradientFadeOutColor.primary2} 9.2%, ${colors.primary2[50]} 91.7%)`
                            : colors.primary2[50]

            },
            '&.alert--info': {
                color: ({ withGradient }) => withGradient ? colors.neutral[900] : colors.neutral[500],
                background:
                    ({ withGradient }) =>
                        withGradient
                            ? `linear-gradient(78.05deg, ${gradientFadeOutColor.neutral} 9.2%, ${colors.neutral[50]} 91.7%)`
                            : colors.neutral[100]

            },
            '& .alert--message': {
                display: 'inline-block',
                verticalAlign: 'middle'
            },
            '& .alert--icon': {
                marginRight: '4px',
                flexShrink: 0
            },
            '& .alert--close-icon': {
                marginLeft: 'auto',
                cursor: 'pointer'
            },
            '& .alert--button': {
                marginLeft: 0
            }
        }
    }
}
export default style
